"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _lib = require("@cimpress/react-components/lib");

var _DatePicker = _interopRequireDefault(require("@cimpress/react-components/lib/DatePicker"));

var _moment = _interopRequireDefault(require("moment"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function SelectExpectedShipDate(_ref) {
  var name = _ref.name,
      isClearable = _ref.isClearable,
      _onChange = _ref.onChange,
      options = _ref.options,
      value = _ref.value;

  var _useState = (0, _react.useState)(),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      minDate = _useState2[0],
      setMinDate = _useState2[1];

  var _useState3 = (0, _react.useState)(),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      maxDate = _useState4[0],
      setMaxDate = _useState4[1];

  return /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      marginTop: '20px',
      marginBottom: '8px'
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      fontSize: '14px',
      fontWeight: '600',
      marginBottom: '16px'
    }
  }, name), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'left',
      marginBottom: '8px'
    }
  }, options.map(function (predefinedTimePeriod, index) {
    return /*#__PURE__*/_react["default"].createElement(_lib.Button, {
      style: _objectSpread({
        marginBottom: '8px',
        padding: '8px 12px',
        minWidth: '100px'
      }, index !== options.length - 1 ? {
        marginRight: '8px'
      } : {}),
      onClick: function onClick() {
        var today = (0, _moment["default"])();

        if (predefinedTimePeriod === 'Today') {
          var todayStr = today.format('MM/DD/YYYY');
          setMinDate(todayStr);
          setMaxDate(todayStr);

          _onChange({
            start: todayStr,
            end: todayStr
          });
        } else if (predefinedTimePeriod === 'Tomorrow') {
          var tomorrowStr = today.add(1, 'day').format('MM/DD/YYYY');
          setMinDate(tomorrowStr);
          setMaxDate(tomorrowStr);

          _onChange({
            start: tomorrowStr,
            end: tomorrowStr
          });
        } else if (predefinedTimePeriod === 'This Week') {
          var weekStartStr = today.startOf('week').format('MM/DD/YYYY');
          var weekEndStr = today.endOf('week').format('MM/DD/YYYY');
          setMinDate(weekStartStr);
          setMaxDate(weekEndStr);

          _onChange({
            start: weekStartStr,
            end: weekEndStr
          });
        } else if (predefinedTimePeriod === 'This Month') {
          var monthStartStr = today.startOf('month').format('MM/DD/YYYY');
          var monthEndStr = today.endOf('month').format('MM/DD/YYYY');
          setMinDate(monthStartStr);
          setMaxDate(monthEndStr);

          _onChange({
            start: monthStartStr,
            end: monthEndStr
          });
        }
      }
    }, predefinedTimePeriod);
  })), /*#__PURE__*/_react["default"].createElement(_lib.FlexBox, {
    spaceBetween: true,
    noGrow: true
  }, /*#__PURE__*/_react["default"].createElement(_DatePicker["default"], {
    label: "Start",
    id: 'expectedShipDate-start',
    className: "expected-ship-date-picker start",
    timeFormat: false,
    onChange: function onChange(selectedValue) {
      if (selectedValue) {
        var selectedDate = selectedValue.format('MM/DD/YYYY');
        setMinDate(selectedDate);
        if (!(value !== null && value !== void 0 && value.end)) setMaxDate(selectedDate);

        _onChange({
          start: selectedDate,
          end: (value === null || value === void 0 ? void 0 : value.end) || selectedDate
        });
      } else {
        // clear
        setMinDate(null);

        _onChange({
          start: null,
          end: (value === null || value === void 0 ? void 0 : value.end) || null
        });
      }
    },
    isValidDate: function isValidDate(selectedDate) {
      if (!maxDate || selectedDate.isSameOrBefore((0, _moment["default"])(maxDate))) return true;
      return false;
    },
    value: (value === null || value === void 0 ? void 0 : value.start) || null,
    isClearable: isClearable
  }), /*#__PURE__*/_react["default"].createElement(_DatePicker["default"], {
    label: "End",
    id: 'expectedShipDate-end',
    className: "expected-ship-date-picker end",
    timeFormat: false,
    onChange: function onChange(selectedValue) {
      if (selectedValue) {
        var selectedDate = selectedValue.format('MM/DD/YYYY');
        setMaxDate(selectedDate);
        if (!(value !== null && value !== void 0 && value.start)) setMinDate(selectedDate);

        _onChange({
          start: (value === null || value === void 0 ? void 0 : value.start) || selectedDate,
          end: selectedDate
        });
      } else {
        // clear
        setMaxDate(null);

        _onChange({
          start: (value === null || value === void 0 ? void 0 : value.start) || null,
          end: null
        });
      }
    },
    isValidDate: function isValidDate(selectedDate) {
      if (!minDate || selectedDate.isSameOrAfter((0, _moment["default"])(minDate))) return true;
      return false;
    },
    value: (value === null || value === void 0 ? void 0 : value.end) || null,
    isClearable: isClearable
  })));
}

var _default = SelectExpectedShipDate;
exports["default"] = _default;